import { GridColumn as Column, GridColumnMenuFilter } from "@progress/kendo-react-grid";
import * as React from "react";
import { LoadTypeCell } from "./LoadTypeCell/LoadTypeCell";
import { isArrayUndefinedOrEmpty } from "../../../../Utils/arrays";
import { KendoReactColoredFooterCell } from "../../../../Layout/Grid/Cell/KendoReactColoredFooterCell";
import { PdsrClientViewModel } from "../../../ViewModel/PdsrClientViewModel";
import { SpdrClientViewModel } from "../../../ViewModel/SpdrClientViewModel";

type Props = {
  odcs: Array<string> | undefined;
  ftlRouteNumber: string | undefined;
  clientViewModels?: PdsrClientViewModel[] | SpdrClientViewModel[];
  disableColumn: boolean;
};

export const generateOdcColumns = ({
  odcs,
  ftlRouteNumber,
  clientViewModels,
  disableColumn,
}: Props) => {
  const odcColumns: JSX.Element[] = [];
  if (!odcs || odcs.length <= 0) {
    return odcColumns;
  }

  const kendoReactColoredFooterCell = (cellText?: string) => {
    return !isArrayUndefinedOrEmpty(clientViewModels) ? (
      <KendoReactColoredFooterCell cellText={cellText} />
    ) : (
      <td />
    );
  };

  odcs.forEach((odc) => {
    odcColumns.push(
      <Column
        key={odc}
        field={odc}
        title={odc}
        filter="text"
        columnMenu={GridColumnMenuFilter}
        cell={(props) => (
          <LoadTypeCell ftlRouteNumber={ftlRouteNumber} {...props} disabled={disableColumn} />
        )}
        width="110"
        sortable={false}
        editable={!disableColumn}
        resizable
        footerCell={() => kendoReactColoredFooterCell()}
      />
    );
  });

  return odcColumns;
};
